import React, { useEffect, useState } from "react";
import "./DeleteUserModal.css";
import { RootState } from "../../redux/type";
import Button from "../UI/Button";
import { useDispatch, } from "react-redux";
import { deleteUserInDatabase } from "../../redux/createMessage/slice";
import firebase from "../../firebase/config";
import "firebase/firestore";
import { signOut } from "../../redux/firebaseState/slice";

interface IModal {
    setLogoutModalOpen: (isOpen: boolean) => void;
  }
  

const LogoutModal = ({ setLogoutModalOpen} : IModal) =>{
    const dispatch= useDispatch();
    const logoutAdmin=(e :any )=>{
      e.preventDefault()
          dispatch(signOut());
          setLogoutModalOpen(false)
    }

    return (
    <div className="modalBackground">
      <div className="modalContainer">
        <div className="title">
          <h1>Logout </h1>
        </div>
        <div className="body py-2">
            <div className="col-md-12">
                <form onSubmit={logoutAdmin}>
                    <h2 className="py-2">Are you sure want to Logout?</h2>
                    <div className="footer">
                        <Button type="submit" text="Yes" className="btn btn-danger"/>
                        <Button text="No" className="btn btn-primary" onClick={() => {setLogoutModalOpen(false)}}/>
                      </div>                                 
                </form>
            </div>
        </div>
        
      </div>
    </div>
  );
}

export default LogoutModal;
